module.exports = __webpack_public_path__ + "static/media/charity.c9684cfb.png";